const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b197310f-b08a-4948-ba2e-ff07e88c06ca",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 9.05 8.42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M.7,8.42a.67.67,0,0,1-.49-.21.69.69,0,0,1,0-1l7-7a.69.69,0,0,1,1,0,.69.69,0,0,1,0,1l-7,7A.7.7,0,0,1,.7,8.42Z",
    style: {
      fill: "#575757"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.35,8.42a.67.67,0,0,1-.49-.21l-7-7a.71.71,0,0,1,0-1,.69.69,0,0,1,1,0l7,7a.71.71,0,0,1-.5,1.2Z",
    style: {
      fill: "#575757"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseLight);
export default __webpack_public_path__ + "static/media/close_light.38f754c0b75f16283d86de5e2626ce0d.svg";
export { ForwardRef as ReactComponent };